  let currentPage = 1;
  let totalPages = 1;
  let allCitationItems = [];
  let filteredCitationItems = [];
  let isSearchActive = false;
  let searchTerm = '';
  let currentSortOption = 'publish_date_desc';
  let isPageTransition = false;
  let isRestoringState = false;

  function getItemsPerPage() {
    const container = document.getElementById('citations-container');
    if (!container) return 8;

    const containerWidth = container.offsetWidth;
    const itemMinWidth = 400;
    const gap = 30;

    const possibleColumns = Math.floor((containerWidth + gap) / (itemMinWidth + gap));
    const actualColumns = Math.max(1, Math.min(possibleColumns, 3));

    console.log('Container width:', containerWidth, 'Columns:', actualColumns);

    if (actualColumns === 1) return 8;
    if (actualColumns === 2) return 8;
    if (actualColumns === 3) return 9;

    return 8;
  }

  document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM loaded, initializing citations...');

    isRestoringState = restoreStateFromURL();

    const citationsContainer = document.getElementById('citations-container');
    if (citationsContainer) {
      allCitationItems = Array.from(citationsContainer.querySelectorAll('.citation-item'));
      console.log('Found citation items:', allCitationItems.length);
    }

    const paginationContainer = document.getElementById('pagination-container');
    if (paginationContainer) {
      paginationContainer.style.display = 'flex';
    }

    applySorting();

    if (isRestoringState) {
      console.log('Restoring state from URL:', {
        page: currentPage,
        sort: currentSortOption,
        search: searchTerm,
        isSearch: isSearchActive,
      });

      if (isSearchActive && searchTerm) {
        performSearch(searchTerm, false);
      } else {
        initializePagination();
      }
    } else {
      initializePagination();
    }

    initializeProductArrows();
    initializeSearch();
    initializeSorting();
    initializeTouchHandling();

    window.addEventListener('resize', function () {
      setTimeout(() => {
        if (!isSearchActive) {
          initializePagination();
        } else {
          updateSearchResults();
        }
      }, 100);
    });

    window.addEventListener('hashchange', function () {
      if (!isPageTransition) {
        const restored = restoreStateFromURL();
        if (restored) {
          if (isSearchActive && searchTerm) {
            performSearch(searchTerm, false);
          } else {
            initializePagination();
          }
        }
      }
    });
  });

  function initializeTouchHandling() {
    let startY = 0;

    document.addEventListener(
      'touchstart',
      function (e) {
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (e) {
        if (window.scrollY === 0) {
          const currentY = e.touches[0].clientY;
          const deltaY = currentY - startY;

          if (deltaY > 100 && e.cancelable) {
            e.preventDefault();
          }
        }
      },
      { passive: false }
    );
  }

  function initializeSorting() {
    const sortSelect = document.getElementById('citation-sort');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function () {
      currentSortOption = this.value;
      console.log('Sort option changed to:', currentSortOption);
      applySorting();

      if (isSearchActive) {
        updateSearchResults();
      } else {
        initializePagination();
      }

      saveStateToURL();
    });
  }

  function applySorting() {
    const container = document.getElementById('citations-container');
    if (!container) return;

    const items = Array.from(container.querySelectorAll('.citation-item'));
    console.log('Applying sorting to', items.length, 'items, option:', currentSortOption);

    items.sort((a, b) => {
      switch (currentSortOption) {
        case 'publish_date_desc':
          const dateA = a.dataset.publishDate;
          const dateB = b.dataset.publishDate;

          if (!dateA && !dateB) return 0;
          if (!dateA) return 1;
          if (!dateB) return -1;

          return new Date(dateB) - new Date(dateA);

        case 'publish_date_asc':
          const dateA2 = a.dataset.publishDate;
          const dateB2 = b.dataset.publishDate;

          if (!dateA2 && !dateB2) return 0;
          if (!dateA2) return 1;
          if (!dateB2) return -1;

          return new Date(dateA2) - new Date(dateB2);

        case 'alphabet_asc':
          const titleA = a.dataset.title || '';
          const titleB = b.dataset.title || '';
          return titleA.localeCompare(titleB);

        case 'alphabet_desc':
          const titleA2 = a.dataset.title || '';
          const titleB2 = b.dataset.title || '';
          return titleB2.localeCompare(titleA2);

        default:
          return 0;
      }
    });

    container.innerHTML = '';
    items.forEach((item) => container.appendChild(item));

    allCitationItems = items;
    console.log('Sorting applied, items reordered');

    if (!isSearchActive) {
      initializePagination();
    }
  }

  function initializeSearch() {
    const searchInput = document.getElementById('citation-search');
    const clearButton = document.getElementById('clear-search');
    const searchIcon = document.getElementById('search-icon-clickable');

    if (!searchInput || !clearButton || !searchIcon) return;

    searchInput.addEventListener('input', function () {
      const value = this.value.trim();
      searchTerm = value;

      if (value) {
        clearButton.style.display = 'flex';
        performSearch(value);
      } else {
        clearButton.style.display = 'none';
        clearSearch();
      }
    });

    searchIcon.addEventListener('click', function () {
      const value = searchInput.value.trim();
      if (value) {
        performSearch(value);
      } else {
        searchInput.focus();
      }
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const value = this.value.trim();
        if (value) {
          performSearch(value);
        }
        this.blur();
      }
    });

    clearButton.addEventListener('click', function () {
      searchInput.value = '';
      searchTerm = '';
      this.style.display = 'none';
      clearSearch();
      searchInput.focus();
    });
  }

  function performSearch(query, resetPage = true) {
    const searchQuery = query.toLowerCase();
    isSearchActive = true;

    console.log('Performing search for:', searchQuery);

    filteredCitationItems = allCitationItems.filter((item) => {
      const journalName = item.dataset.journal || '';
      const articleTitle = item.dataset.title || '';
      const authors = item.dataset.authors || '';
      const institutions = item.dataset.institutions || '';

      const productItems = item.querySelectorAll('.product-names');
      const productNames = Array.from(productItems)
        .map((el) => el.textContent?.toLowerCase() || '')
        .join(' ');

      const catalogItems = item.querySelectorAll('.catalog-number');
      const catalogNumbers = Array.from(catalogItems)
        .map((el) => el.textContent?.toLowerCase() || '')
        .join(' ');

      return (
        journalName.includes(searchQuery) ||
        articleTitle.includes(searchQuery) ||
        authors.includes(searchQuery) ||
        institutions.includes(searchQuery) ||
        productNames.includes(searchQuery) ||
        catalogNumbers.includes(searchQuery)
      );
    });

    console.log('Search results:', filteredCitationItems.length);

    if (resetPage) {
      currentPage = 1;
    }

    updateSearchResults();
    saveStateToURL();
  }

  function clearSearch() {
    isSearchActive = false;
    filteredCitationItems = [];
    searchTerm = '';

    const searchInput = document.getElementById('citation-search');
    const clearButton = document.getElementById('clear-search');
    const resultsInfo = document.getElementById('search-results-info');
    const noResults = document.getElementById('no-results');

    if (searchInput) searchInput.value = '';
    if (clearButton) clearButton.style.display = 'none';
    if (resultsInfo) resultsInfo.style.display = 'none';
    if (noResults) noResults.style.display = 'none';

    allCitationItems.forEach((item) => {
      item.classList.remove('hidden');
      item.style.display = 'block';
    });

    const citationsContainer = document.getElementById('citations-container');
    if (citationsContainer) {
      citationsContainer.style.display = 'grid';
    }

    initializePagination();

    saveStateToURL();
  }

  function updateSearchResults() {
    const resultsInfo = document.getElementById('search-results-info');
    const noResults = document.getElementById('no-results');
    const citationsContainer = document.getElementById('citations-container');
    const paginationContainer = document.getElementById('pagination-container');

    if (filteredCitationItems.length === 0) {
      if (resultsInfo) resultsInfo.style.display = 'none';
      if (noResults) noResults.style.display = 'block';
      if (citationsContainer) citationsContainer.style.display = 'none';
      if (paginationContainer) paginationContainer.style.display = 'none';
    } else {
      if (noResults) noResults.style.display = 'none';
      if (citationsContainer) citationsContainer.style.display = 'grid';

      if (resultsInfo) {
        resultsInfo.textContent = `Found ${filteredCitationItems.length} citations matching "${searchTerm}"`;
        resultsInfo.style.display = 'block';
      }

      const itemsPerPage = getItemsPerPage();
      const totalItems = filteredCitationItems.length;
      totalPages = Math.ceil(totalItems / itemsPerPage);

      currentPage = Math.max(1, Math.min(currentPage, totalPages));

      console.log(
        'Search pagination: totalItems=',
        totalItems,
        'itemsPerPage=',
        itemsPerPage,
        'totalPages=',
        totalPages,
        'currentPage=',
        currentPage
      );

      if (totalPages <= 1) {
        if (paginationContainer) paginationContainer.style.display = 'none';
        allCitationItems.forEach((item) => {
          if (filteredCitationItems.includes(item)) {
            item.classList.remove('hidden');
            item.style.display = 'block';
          } else {
            item.classList.add('hidden');
            item.style.display = 'none';
          }
        });
      } else {
        if (paginationContainer) paginationContainer.style.display = 'flex';
        generatePaginationLinks();
        showSearchResults(currentPage);
      }
    }

    initializeProductArrows();
  }

  function showSearchResults(page) {
    const itemsPerPage = getItemsPerPage();
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    console.log(
      `Showing search results page ${page}: items ${startIndex} to ${endIndex - 1} of ${filteredCitationItems.length}`
    );

    allCitationItems.forEach((item) => {
      item.classList.add('hidden');
      item.style.display = 'none';
    });

    const itemsToShow = filteredCitationItems.slice(startIndex, endIndex);
    itemsToShow.forEach((item) => {
      item.classList.remove('hidden');
      item.style.display = 'block';
    });

    currentPage = page;
    updatePaginationLinks();
  }

  function initializePagination() {
    const citationsContainer = document.getElementById('citations-container');
    const paginationContainer = document.getElementById('pagination-container');

    if (isSearchActive) {
      return;
    }

    allCitationItems.forEach((item) => {
      item.classList.remove('hidden');
      item.style.display = 'block';
    });

    const itemsPerPage = getItemsPerPage();
    const totalItems = allCitationItems.length;
    totalPages = Math.ceil(totalItems / itemsPerPage);

    currentPage = Math.max(1, Math.min(currentPage, totalPages));

    console.log(
      'Pagination: totalItems=',
      totalItems,
      'itemsPerPage=',
      itemsPerPage,
      'totalPages=',
      totalPages,
      'currentPage=',
      currentPage
    );

    if (totalPages <= 1) {
      if (paginationContainer) {
        paginationContainer.style.display = 'none';
      }
      allCitationItems.forEach((item) => {
        item.classList.remove('hidden');
        item.style.display = 'block';
      });
    } else {
      if (paginationContainer) {
        paginationContainer.style.display = 'flex';
      }
      generatePaginationLinks();
      showPage(currentPage);
    }

    initializeProductArrows();
  }

  function showPage(page) {
    const itemsPerPage = getItemsPerPage();
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    console.log(`Showing page ${page}: items ${startIndex} to ${endIndex - 1} of ${allCitationItems.length}`);

    allCitationItems.forEach((item, index) => {
      if (index >= startIndex && index < endIndex) {
        item.classList.remove('hidden');
        item.style.display = 'block';
      } else {
        item.classList.add('hidden');
        item.style.display = 'none';
      }
    });

    currentPage = page;
    updatePaginationLinks();
  }

  function generatePaginationLinks() {
    const paginationContainer = document.getElementById('pagination-container');
    if (!paginationContainer) return;

    paginationContainer.innerHTML = '';

    const prevItem = document.createElement('div');
    prevItem.className = 'pagination-item';
    const prevClass = currentPage > 1 ? 'pagination-nav' : 'pagination-nav disabled';
    prevItem.innerHTML = `<a href="#" class="${prevClass}" onclick="${
      currentPage > 1 ? `changePage(${currentPage - 1}); return false;` : 'return false;'
    }">
<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
</svg>
Prev
</a>`;
    paginationContainer.appendChild(prevItem);

    const isMobile = window.innerWidth <= 749;
    const maxVisiblePages = isMobile ? 5 : 7;

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      let startPage, endPage;

      const sidePages = Math.floor((maxVisiblePages - 2) / 2);

      if (currentPage <= sidePages + 2) {
        startPage = 2;
        endPage = maxVisiblePages - 1;
      } else if (currentPage >= totalPages - sidePages - 1) {
        startPage = totalPages - maxVisiblePages + 2;
        endPage = totalPages - 1;
      } else {
        startPage = currentPage - sidePages;
        endPage = currentPage + sidePages;
      }

      startPage = Math.max(2, startPage);
      endPage = Math.min(totalPages - 1, endPage);

      if (startPage > 2) {
        pages.push('...');
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages - 1) {
        pages.push('...');
      }

      pages.push(totalPages);
    }

    pages.forEach((page) => {
      const pageItem = document.createElement('div');
      pageItem.className = 'pagination-item';

      if (page === '...') {
        pageItem.innerHTML = '<span class="pagination-dots">...</span>';
      } else {
        const activeClass = page === currentPage ? ' active' : '';
        pageItem.innerHTML = `<a href="#" class="pagination-link${activeClass}" onclick="changePage(${page}); return false;">${page}</a>`;
      }

      paginationContainer.appendChild(pageItem);
    });

    // Next button
    const nextItem = document.createElement('div');
    nextItem.className = 'pagination-item';
    const nextClass = currentPage < totalPages ? 'pagination-nav' : 'pagination-nav disabled';
    nextItem.innerHTML = `<a href="#" class="${nextClass}" onclick="${
      currentPage < totalPages ? `changePage(${currentPage + 1}); return false;` : 'return false;'
    }">
Next
<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/>
</svg>
</a>`;
    paginationContainer.appendChild(nextItem);
  }

  function updatePaginationLinks() {
    const paginationLinks = document.querySelectorAll('.pagination-link');
    paginationLinks.forEach((link) => {
      link.classList.remove('active');
      if (parseInt(link.textContent) === currentPage) {
        link.classList.add('active');
      }
    });

    const prevNav = document.querySelector('.pagination-nav:first-child');
    const nextNav = document.querySelector('.pagination-nav:last-child');

    if (prevNav) {
      if (currentPage > 1) {
        prevNav.classList.remove('disabled');
      } else {
        prevNav.classList.add('disabled');
      }
    }

    if (nextNav) {
      if (currentPage < totalPages) {
        nextNav.classList.remove('disabled');
      } else {
        nextNav.classList.add('disabled');
      }
    }
  }

  function changePage(page) {
    if (page < 1 || page > totalPages || isPageTransition) return;

    isPageTransition = true;

    const shouldScroll = page !== currentPage;

    if (isSearchActive) {
      showSearchResults(page);
    } else {
      showPage(page);
    }

    generatePaginationLinks();

    saveStateToURL();

    if (shouldScroll) {
      setTimeout(() => {
        const citationsSection = document.querySelector('.citations-section');
        if (citationsSection) {
          const rect = citationsSection.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const targetPosition = rect.top + scrollTop - 20; 

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        }
      }, 100);
    }

    setTimeout(() => {
      isPageTransition = false;
      initializeProductArrows();
    }, 200);
  }

  function saveStateToURL() {
    const state = {
      page: currentPage,
      sort: currentSortOption,
      search: searchTerm,
      isSearch: isSearchActive,
    };

    const stateString = JSON.stringify(state);
    const encodedState = btoa(encodeURIComponent(stateString));

    if (history.replaceState) {
      const newUrl = window.location.pathname + '#' + encodedState;
      history.replaceState(null, null, newUrl);
    }
  }

  function restoreStateFromURL() {
    const hash = window.location.hash.substring(1);
    if (!hash) return false;

    try {
      const decodedState = decodeURIComponent(atob(hash));
      const state = JSON.parse(decodedState);

      if (state.page) currentPage = parseInt(state.page);
      if (state.sort) {
        currentSortOption = state.sort;
        const sortSelect = document.getElementById('citation-sort');
        if (sortSelect) {
          sortSelect.value = state.sort;
          applySorting();
        }
      }
      if (state.search) {
        searchTerm = state.search;
        const searchInput = document.getElementById('citation-search');
        const clearButton = document.getElementById('clear-search');
        if (searchInput) {
          searchInput.value = state.search;
          if (state.search) {
            clearButton.style.display = 'flex';
          }
        }
      }
      if (state.isSearch !== undefined) isSearchActive = state.isSearch;

      return true;
    } catch (e) {
      console.log('Could not restore state from URL:', e);
      return false;
    }
  }

  function initializeProductArrows() {
    const containers = document.querySelectorAll('.products-container');

    containers.forEach((container, index) => {
      const wrapper = container.closest('.products-wrapper');
      if (!wrapper) return;

      const leftArrow = wrapper.querySelector('.scroll-arrow.left');
      const rightArrow = wrapper.querySelector('.scroll-arrow.right');

      function updateArrows() {
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;

        if (scrollLeft > 0) {
          leftArrow.classList.add('visible');
        } else {
          leftArrow.classList.remove('visible');
        }

        if (scrollLeft < scrollWidth - clientWidth - 1) {
          rightArrow.classList.add('visible');
        } else {
          rightArrow.classList.remove('visible');
        }
      }

      updateArrows();
      container.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
    });
  }

  function scrollProducts(arrow, direction) {
    const wrapper = arrow.closest('.products-wrapper');
    const container = wrapper.querySelector('.products-container');
    const firstProduct = container.querySelector('.product-item');
    const scrollAmount = firstProduct ? firstProduct.offsetWidth + 15 : 300;

    if (direction === 'left') {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  }
